class DialogQuickBuyRenderer extends HTMLElement {
  connectedCallback () {
    this.setEventListeners()
  }

  setEventListeners () {
    document.addEventListener('quick-add:load', this.onLoad.bind(this))
    this.addEventListener('quick-add:clear', this.resetState.bind(this))
  }

  async onLoad (event) {
    this.productHandle = event.detail.handle
    this.root = event.detail.root
    await this.fetchSection()
  }

  resetState () {
    document.querySelector('html').style.overflow = 'auto'
    this.dataset.rendered = 'false'

    if (this.els.dialogInner) {
      this.els.dialogInner.classList.remove('dialog-transition-ready', 'dialog-transition-active')
    }

    this.innerHTML = ''

  }

  async fetchSection () {
    try {
      const response = await fetch(`/products/${this.productHandle}/?section_id=dialog-quick-buy`)
      const section = await response.text()

      const innerHTML = new DOMParser()
        .parseFromString(section, 'text/html')
        .querySelector('#shopify-section-dialog-quick-buy').innerHTML

      if (this.querySelector('dialog-quick-buy')) {
        this.innerHTML = ''
      }

      this.insertAdjacentHTML('beforeend', innerHTML)


      setTimeout(() => {
        this.els = {
          dialogInner: this.querySelector('[data-dialog-quick-buy-el="inner"]'),
        }

        if (this.root) {
          this.querySelector('dialog-quick-buy').setAttribute('data-root', this.root)
        }

        this.querySelector('.dialog-quick-add__dialog-inner').scrollTop = 0

        // Use a more reliable approach with explicit class toggling
        this.els.dialogInner.classList.add('dialog-transition-ready')

        requestAnimationFrame(() => {
          this.els.dialogInner.classList.add('dialog-transition-active')
        })
      }, 250);




    } catch (error) {
      console.error('Error:', error)
    }
  }
}

customElements.define('dialog-quick-buy-renderer', DialogQuickBuyRenderer)
